import { Trans } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import type { CompanyDomainValue } from "app/pages/sales-intelligence/domain/leads/types/website";

import { findMainCompanyDomain } from "../../../utils/rows";

import { DATA_AUTOMATION_COMPANY_DOMAINS_SUMMARY } from "./const";
import { StyledCount, StyledDomain } from "./styles";

type Props = {
    companyDomains: readonly CompanyDomainValue[];
};

export const CompanyDomainsSummary = ({ companyDomains }: Props) => {
    const mainDomain = findMainCompanyDomain(companyDomains);

    if (!mainDomain) {
        return null;
    }

    return (
        <Flex
            data-automation={DATA_AUTOMATION_COMPANY_DOMAINS_SUMMARY}
            columnGap="4px"
            alignItems="center"
            minWidth={0}
            flex="0 1 auto"
        >
            <StyledDomain
                data-automation={`${DATA_AUTOMATION_COMPANY_DOMAINS_SUMMARY}-name`}
                fontVariant="subtitle2"
                color={colorsPalettes.carbon[500]}
            >
                {mainDomain.domain}
            </StyledDomain>

            <StyledCount
                data-automation={`${DATA_AUTOMATION_COMPANY_DOMAINS_SUMMARY}-count`}
                fontVariant="body2"
                color={colorsPalettes.carbon[300]}
            >
                ·&nbsp;
                {companyDomains.length}
                &nbsp;
                <Trans
                    i18nKey="si.leads_search.company_domains.domain"
                    count={companyDomains.length}
                />
            </StyledCount>
        </Flex>
    );
};
